import { combineReducers } from "redux";
import constants from "modules/contact/constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  getContactInfoResult: createApiReducer(constants.GET_CONTACT_INFO, {}),
});

export default reducers;
